<div class="map-wrapper">
  @if (!isInTranscriptUpload || !isProcessingTranscript) {
    <div class="canvas-control-bar">
      <div class="toolbar-icons">
        <p-button
          class="dap-previous-page"
          icon="fa-solid fa-caret-up"
          severity="contrast"
          tooltipPosition="bottom"
          showDelay="500"
          [ariaLabel]="'documentToolbar.previousPage' | translate"
          [pTooltip]="'documentToolbar.previousPage' | translate"
          [text]="true"
          (click)="previousPage()"
        ></p-button>
        <div class="page-number">
          <span>{{ currentPage }} {{ 'documentToolbar.of' | translate }} {{ totalPages }}</span>
        </div>
        <p-button
          class="dap-next-page"
          icon="fa-solid fa-caret-down"
          severity="contrast"
          tooltipPosition="bottom"
          showDelay="500"
          [ariaLabel]="'documentToolbar.nextPage' | translate"
          [pTooltip]="'documentToolbar.nextPage' | translate"
          [text]="true"
          (click)="nextPage()"
        ></p-button>
        <p-divider layout="vertical" />
        <p-button
          class="dap-zoom-in"
          icon="fa-regular fa-magnifying-glass-plus"
          severity="contrast"
          tooltipPosition="bottom"
          showDelay="500"
          [ariaLabel]="'documentToolbar.zoomIn' | translate"
          [pTooltip]="'documentToolbar.zoomIn' | translate"
          [text]="true"
          (click)="zoomIn()"
        ></p-button>
        <p-button
          class="dap-zoom-out"
          icon="fa-regular fa-magnifying-glass-minus"
          severity="contrast"
          tooltipPosition="bottom"
          showDelay="500"
          [ariaLabel]="'documentToolbar.zoomOut' | translate"
          [pTooltip]="'documentToolbar.zoomOut' | translate"
          [text]="true"
          (click)="zoomOut()"
        ></p-button>
        <p-divider layout="vertical" />
        <p-button
          class="dap-recenter"
          icon="fa-regular fa-arrows-to-dot"
          severity="contrast"
          tooltipPosition="bottom"
          showDelay="500"
          [ariaLabel]="'documentToolbar.recenter' | translate"
          [pTooltip]="'documentToolbar.recenter' | translate"
          [text]="true"
          (click)="recenter()"
        ></p-button>
        <p-button
          class="dap-rotate"
          icon="fa-solid fa-rotate-right"
          severity="contrast"
          tooltipPosition="bottom"
          showDelay="500"
          [ariaLabel]="'documentToolbar.rotate' | translate"
          [pTooltip]="'documentToolbar.rotate' | translate"
          [text]="true"
          (click)="rotate()"
        ></p-button>
        @if (isInTranscriptUpload && hasAnnotations() && sendFromContentFlag()) {
          <p-divider layout="vertical" />
          <p-button
            class="dap-hide-show-annotations"
            severity="contrast"
            tooltipPosition="bottom"
            showDelay="500"
            [icon]="showAnnotations() ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'"
            [pTooltip]="
              (showAnnotations()
                ? 'documentToolbar.hideAnnotations'
                : 'documentToolbar.showAnnotations'
              ) | translate
            "
            [ariaLabel]="
              (showAnnotations()
                ? 'documentToolbar.hideAnnotations'
                : 'documentToolbar.showAnnotations'
              ) | translate
            "
            [text]="true"
            (click)="toggleAnnotations()"
          ></p-button>
        }
        @if (!isInTranscriptUpload) {
          <p-divider layout="vertical" />
          <p-button
            class="dap-split-document"
            icon="fa-regular fa-file-dashed-line"
            severity="contrast"
            tooltipPosition="bottom"
            showDelay="500"
            [ariaLabel]="splitButtonTooltip | translate"
            [pTooltip]="splitButtonTooltip | translate"
            [text]="true"
            [disabled]="disableSplitButton"
            (click)="onSplitClick()"
          ></p-button>
        }
      </div>

      <div class="toolbar-icons">
        @if (!isInTranscriptUpload && docExpirationUiEnabled() && expirationDate) {
          <p-divider layout="vertical" />
          <p class="expiration-date">
            {{
              'documentExpiringOn'
                | translate: { date: expirationDate | date: 'MM/dd/yyyy' : 'UTC' }
            }}
          </p>
        }
        @if (isInTranscriptUpload && sendFromContentFlag() && hasEcmDocId) {
          <p-divider layout="vertical" />
          <p-button
            class="dap-go-to-document"
            icon="fa-solid fa-up-right-from-square"
            severity="contrast"
            tooltipPosition="bottom"
            showDelay="500"
            [ariaLabel]="'goToDocument' | translate"
            [pTooltip]="'goToDocument' | translate"
            [text]="true"
            (click)="goToDocument()"
          ></p-button>
        }
      </div>
    </div>
  }
  <div
    id="map-viewer"
    class="map-container"
  ></div>
</div>
